<template>

  <div>
    <vx-card ref="filterCard" :title="$t('Filtros')" class="mb-2" :collapse-action="true" >

     <vs-row vs-type="flex" vs-justify="space-between">
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">
          <label class="vs-input--label">{{$t("TelaAgendaEventos_lTipo")}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="3">          
            <v-select                   
                  :reduce="tipo => tipo.data" 
                  :options="listaTiposEventos" 
                  :clearable="false"
                  v-model="filtro.cmbTipo"       
                  class="v-select w-full"></v-select> 
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">
          <label class="vs-input--label">{{$t("TelaAgendaEventos_lStatus")}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="3">          
          <v-select                   
                  :reduce="tipo => tipo.data" 
                  :options="listaStatusEventos" 
                  v-model="filtro.cmbStatus"      
                  :clearable="false" 
                  class="v-select w-full"></v-select> 
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">
          <label class="vs-input--label">{{$t("TelaAgendaEventos_lVeiculo")}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="left" vs-w="3">          
            <v-select 
                label="placa"
                :filter="pesquisarVeiculo"
                :options="listaVeiculos" 
                  :reduce="v => v.idVeiculo" 
                v-model="filtro.idVeiculo"                                   
                class="v-select w-full">
            <template #option="{  placa, modelo, labelVeiculo, marcaModulo  }">
                <small :style="{ color: getCorMarcaModulo(marcaModulo) }"><strong> {{modelo}} </strong>  
                <em> - {{placa}} </em> <em v-if="labelVeiculo">/ {{labelVeiculo}} </em></small>
            </template>
            <template #selected-option="{ placa, labelVeiculo  }">                          
                <small style="font-size:0.70vw">{{placa}} <em v-if="labelVeiculo">/ {{labelVeiculo}} </em></small>
            </template>
            <template #no-options="">
                {{ $t('NenhumVeiculoEncontrado') }}
            </template>
          </v-select>  
        </vs-col>                
      </vs-row>
      <vs-row vs-type="flex" vs-justify="space-between" class="mt-2">
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">
          <label class="vs-input--label">{{$t("Periodo")}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="5">      
          <v-select                   
                  :reduce="tipo => tipo.data" 
                  :options="listaOpcoesFiltroData" 
                  v-model="filtro.rgUsoDataFiltro"       
                  :clearable="false"
                  class="v-select w-full mr-2"></v-select>               
          <flat-pickr v-model="filtro.dataInicio" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker" v-if="filtro.rgUsoDataFiltro"/>
          <label class="vs-input--label mr-2">à</label>
          <flat-pickr v-model="filtro.dataFim" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker"/>
        </vs-col>                      
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">          
          <label class="vs-input--label mr-2">Número</label>
          <vs-input v-model="filtro.id" class="w-full" @keyup.enter.native="fetchLista(filtro)"/>                
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2">
          <vx-tooltip :text="$t('Pesquisa')">              
            <vs-button class="mr-2" radius color="primary" type="filled" icon-pack="feather" icon="icon-search" @click="fetchLista(filtro)"></vs-button>
          </vx-tooltip>
          <vx-tooltip :text="$t('LimparFiltros')">              
            <vs-button class="mr-2" radius color="dark" type="border" icon-pack="feather" icon="icon-file" @click="limparFiltros"></vs-button>  
          </vx-tooltip>
          <vx-tooltip :text="$t('Novo')">              
            <vs-button class="mr-2" radius color="warning" type="filled" icon-pack="feather" icon="icon-plus" @click="routeNovoRegistro"></vs-button>          
          </vx-tooltip>
          <vx-tooltip :text="$t('ExportarParaCSV')">              
            <vs-button class="mr-2" radius color="rgb(11, 189, 135)" type="filled" icon-pack="feather" icon="icon-save" @click="exportarParaCSV"></vs-button>  
          </vx-tooltip>
        </vs-col>    
        
      </vs-row>
      
    </vx-card>

     <vx-card>
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"           
        :gridOptions="configuracaoGrid.gridOptions"
        class="ag-theme-material ag-grid-table ag-grid-altura"
        :columnDefs="configuracaoGrid.columnDefs"
        :defaultColDef="configuracaoGrid.defaultColDef"
        :rowData="dadosDaGrid"
        :headerHeight="25"
        :rowHeight="25"
        rowSelection="single"
        colResizeDefault="shift"
        @row-selected="onRowSelectedRegistro"    
        :animateRows="true"
        :floatingFilter="false"
        :pagination="false"
        :paginationAutoPageSize="false"
        :suppressPaginationPanel="true"
        >
      </ag-grid-vue>
      <small v-if="dadosDaGrid.length">REGISTROS: {{dadosDaGrid.length}} </small>      
    </vx-card>     
  </div>

</template>

<script>
import axios from "@/axios.js"
import flatPickr from 'vue-flatpickr-component';
import { AgGridVue } from "ag-grid-vue"
import '@/assets/concept/scss/tabelaBasica.scss'
import 'flatpickr/dist/flatpickr.css';
import {Portuguese as PortugueseLocale} from 'flatpickr/dist/l10n/pt.js';
//import {english as EnglishLocale} from 'flatpickr/dist/l10n/default.js'
//import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'
import generico from '@/generico.js'
import 'vue-select/dist/vue-select.css';

const URL_SERVLET = "/AgendaEventosVeiculosRest";
const NAME_ROUTE_EDIT = "frota-agenda-eventos-edit";

import { CONSTANTE_TIPO_EVENTO_VEICULO_ARRAY_OP_TODOS } from '@/constantesComboBox.js'
import { CONSTANTE_STATUS_EVENTO_AGENDA_ARRAY_OP_TODOS } from '@/constantesComboBox.js'

export const CONSTANTE_OPCAO_DATA_ARRAY = [	
	{label:"Com Data", data:"ComData"},		
	{label:"Sem Data", data:"SemData"},		
	{label:"Todos", data:"TodosComDataSemData"}		
];

export default {
  components: {
    AgGridVue,
    flatPickr
  },
  data() {
    return {
      filtro: {cmbTipo: null, cmbStatus: null, idVeiculo: null, rgUsoDataFiltro: 'TodosComDataSemData', dataInicio: null, dataFim: null, id: null},
      configuracaoGrid: { 
          gridApi: null, gridOptions: {}, 
          defaultColDef: { sortable: true, resizable: true, suppressMenu: true  },
          columnDefs: [        
            { headerName: "#", valueGetter: "node.rowIndex + 1", width: 30 },
            { headerName: 'No.', field: 'numeracao' },     
            { headerName: 'VEÍCULO', field: 'placa' },                 
            { headerName: 'TIPO', field: 'tipoImagem' },                 
            { headerName: 'NOME', field: 'nome' },                 
            { headerName: 'DATA', field: 'data', valueGetter: function(params) { return (params.data.data ? generico.formatarDataYYYYMMDD(params.data.data) : '-')} },                                
            { headerName: 'ODÔMETRO', field: 'km' },                 
            { headerName: 'HORÌMETRO', field: 'horimetro' },
            { headerName: 'STATUS', field: 'status' },                 
            { headerName: 'EMAIL', field: 'email' },                 
          ]
      },
      configDatePicker: {          
          altInput: true,
          altFormat: "d-m-Y",
          dateFormat: "U", 
          altInputClass: "vs-inputx vs-input--input normal hasValue text-center",
          locale: PortugueseLocale
      },
      dadosDaGrid: [],
      totalRegistros: 0,
      listaVeiculos: []     
    }
  },  
  created() {
    this.listaTiposEventos = CONSTANTE_TIPO_EVENTO_VEICULO_ARRAY_OP_TODOS;  
    this.listaStatusEventos = CONSTANTE_STATUS_EVENTO_AGENDA_ARRAY_OP_TODOS;  
    this.listaOpcoesFiltroData = CONSTANTE_OPCAO_DATA_ARRAY;
  },
  computed: {    
    filterSectionHeight() {
      return 320;   
    },    
    paginationPageSize() {
      if(this.configuracaoGrid.gridApi) return this.configuracaoGrid.gridApi.paginationGetPageSize()
      else return 20  
    },
    totalPages() {
      if(this.configuracaoGrid.gridApi) return this.configuracaoGrid.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.configuracaoGrid.gridApi) return this.configuracaoGrid.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.configuracaoGrid.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    getCorMarcaModulo(marcaModulo) {
      return generico.getCorMarcaModulo(marcaModulo);
    },
    fetchVeiculos() {      
      const params = new URLSearchParams();
      params.append('outputFormat', 'JSON');
      params.append('idCliente', this.$store.state.AppActiveUser.id);
      params.append('funcionalidade', 'AGENDA_EVENTOS');

      axios.get("/RecuperarVeiculosAtivosCliente", {
              params, 
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
        
        if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {            
            this.$router.push({ path: '/login' });
        } else {
            this.listaVeiculos = response.data;                           
        }        
      })
      .catch((error) => { 
          /* eslint-disable no-console */   console.log("EFETUAR LOGOFF! - fetchVeiculos - " + error); 
      })       

    },   
    pesquisarVeiculo(options, varTermoPesquisa) {
      
      varTermoPesquisa = varTermoPesquisa.toUpperCase();
      return options.filter(function (veiculo) {
              return (veiculo.marca.toUpperCase().indexOf(varTermoPesquisa) != -1  || veiculo.modelo.toUpperCase().indexOf(varTermoPesquisa) != -1 || 
              veiculo.placa.toUpperCase().indexOf(varTermoPesquisa) != -1 || veiculo.condutor.toUpperCase().indexOf(varTermoPesquisa) != -1 || 
              (veiculo.labelVeiculo && veiculo.labelVeiculo.toUpperCase().indexOf(varTermoPesquisa) != -1)
              ) ;
      })
    },
    limparFiltros() {
      this.filtro.id = null;
      this.filtro.cmbTipo = null;
      this.filtro.cmbStatus = null;
      this.filtro.idVeiculo = null;
      this.filtro.rgUsoDataFiltro ='TodosComDataSemData';
      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.filtro.dataInicio = String(firstDay.getTime()/1000);
      this.filtro.dataFim = String(lastDay.getTime()/1000);      
    },
    fetchLista(filtro) {   
      this.$vs.loading();   
      const params = new URLSearchParams();
      params.append('method', 'FindAll');
      params.append('orderDirection', 'ASC');
      params.append('outputFormat', 'JSON');
      params.append('idCliente', this.$store.state.AppActiveUser.id);
      params.append('rgUsoDataFiltro', filtro.rgUsoDataFiltro);
      
      if (filtro.idVeiculo) {
        params.append('filter1', filtro.idVeiculo);
      }

      if (filtro.cmbStatus) {
        params.append('filter2', filtro.cmbStatus);
      }

      if (filtro.cmbTipo) {
        params.append('tipoEvento', filtro.cmbTipo);
      }

      if (filtro.dataInicio) {
        params.append('dataInicio', filtro.dataInicio*1000);
      }

      if (filtro.dataFim) {
        params.append('dataFim', filtro.dataFim*1000);  
      }

      if (filtro.id) {
        params.append('id', filtro.id);  
      }

      axios.post(URL_SERVLET, params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          this.$vs.loading.close();
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {
              this.dadosDaGrid = response.data;        
              this.totalRegistros = this.dadosDaGrid.length;                               
          }
      })
      .catch((error) => { 
          this.$vs.loading.close();
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaPoI - " + error); 
      })    
                        
    },
    routeNovoRegistro() {
      let self_ = this;

      self_.$router.push({
            name: NAME_ROUTE_EDIT                     
      })
    },
    onRowSelectedRegistro(evento) {
      let self_ = this;
      let registro = evento.node.data;
      
      self_.$router.push({
            name: NAME_ROUTE_EDIT,
            params: {
              registroOriginal: registro
            }
      })

    },
    exportarParaCSV() {
      var params = {columnSeparator: ';', fileName: 'AgendaEventos.csv'};
      this.configuracaoGrid.gridApi.exportDataAsCsv(params);
    }
    
  },
  mounted() {
    this.fetchVeiculos();
    if (this.$store.getters.filtroAgendaEvento) {
        this.filtro = JSON.parse(JSON.stringify(this.$store.getters.filtroAgendaEvento));
    } else {
      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.filtro.dataInicio = String(firstDay.getTime()/1000);
      this.filtro.dataFim = String(lastDay.getTime()/1000);
    }
    
    this.configuracaoGrid.gridApi = this.configuracaoGrid.gridOptions.api        
    this.configuracaoGrid.gridApi.sizeColumnsToFit();   
    this.fetchLista(this.filtro);
  },
  beforeDestroy() {    
    this.$store.dispatch('setarFiltro', {nomeTela: 'agenda-evento' , filtro: this.filtro});
  }
}

</script>
<style lang="scss" scoped>
  .ag-grid-altura{
    height: calc(100vh - 295px);
  }
</style>